import React, { useState } from "react";
import PageHeadings from "../../Components/PageHeadings/PageHeadings";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import DetailsViewContent from "../../Components/DetailsViewComponet/DetailsViewContent";
import Loader from "../../Components/Loader/Loader";

const DetailsView = () => {
  const [loading, setLoading] = useState(false);

  return (
    <div>
      {loading ? <Loader /> : null}

      <Header />
      <div className="page-head-plus-detailsview-content">
        <PageHeadings />
        <DetailsViewContent setLoading={setLoading} />
      </div>
      <Footer />
    </div>
  );
};
export default DetailsView;
